import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { favoriteMarketService } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';

interface UseFavoriteMarketsGoodsParams {
  order?: string;
  categorySno?: number;
}

export const useFavoriteMarketsGoods = ({
  order,
  categorySno,
}: UseFavoriteMarketsGoodsParams) => {
  return useInfiniteQuery({
    queryKey: queryKey.favoriteMarketsGoods({ order, category_sno: categorySno }),
    queryFn: ({ pageParam }: { pageParam?: number }) =>
      favoriteMarketService.getGoods({
        order,
        category_sno: categorySno,
        last_sno: pageParam,
      }),
    initialPageParam: undefined,
    getNextPageParam: page => {
      if (page.is_last) return undefined;
      return page.last_sno ?? undefined;
    },
    select: data => ({
      pages: data.pages,
      items: data.pages.flatMap(page => page.item_list),
    }),
    enabled: order != null,
    placeholderData: keepPreviousData,
  });
};
